import React from "react"

import "./pinterest.css"

const SavorPinterest = () => {
    return (
        <div className="relative pinterest">
            <div className="flex justify-center head">
                <a href="https://www.pinterest.com/website/confirm/" style={{border:'none'}} title="Verify domain">
                    <img alt="Verify website" height="52" src="https://s.pinimg.com/images/email/logo.gif" style={{verticalAlign:'top', outline:'none',border:'none'}} width="200"/>
                </a>
            </div>
            <div className="grid col-3 col-1-sm align-center name">
                <div>
                    {Array.from({ length: 15 }, (_, index) => (
                        <img
                        key={index}
                        src={'https://s.pinimg.com/images/mail/double_rules620.gif'}
                        alt={`${index + 1}` || `Pinterest ${index}`}
                        />
                    ))}
                </div>
                <div style={{ background: 'url(https://s.pinimg.com/images/paper.jpg)', backgroundColor: '#f7f5f5' }}>
                    <h1>Hi, Savor Brands!</h1>
                </div>
                <div>
                    {Array.from({ length: 15 }, (_, index) => (
                        <img key={index} src={'https://s.pinimg.com/images/mail/double_rules620.gif'} alt={`${index + 1}` || `Pinterest ${index}`} />
                    ))}
                </div>
            </div>
            <div className="content">
                <a href="https://www.pinterest.com/website/confirm/" title="Savor Brands">
                    <img className="mb-0" alt="Savor Brands Logo" height="80" src="https://i.pinimg.com/140x140_RS/b9/70/2c/b9702cfc2ad47496912a39fe77e6ccc8.jpg" style={{verticalAlign: 'top', outline: 'none', border: 'none'}} width="80"/>
                </a>
                <p>Looking good! You are ready to return to the verification page and complete the process.</p>

                <a href="https://www.pinterest.com/website/confirm/">Go To Board</a>
            </div>
            <div className="foot text-center">
                <h4 style={{fontFamily:'georgia,serif', fontWeight: 'normal', fontSize: '21px', color:'#211922 !important',textShadow:'0 1px 0 #FFFFFF', margin:0, padding:0}}>Happy Pinning!</h4>
                <img src="https://s.pinimg.com/images/mail/badge_rule620.gif" alt="Pinterest Badge" />
                <p>
                    <span className="symbolfix">©</span>2019 Pinterest, Inc.<font style={{color:'#AAA', padding:'0 2px'}}>|</font> All Rights Reserved<br/>
                    <a href="https://www.pinterest.com/_/_/policy/privacy-policy/" style={{color:'#999', textDecoration:'underline', textShadow: '0 1px 0 #FFFFFF'}}>Privacy Policy</a>
                    <font style={{color:'#AAA', padding: '0 2px'}}> |</font> 
                    <a href="https://www.pinterest.com/_/_/policy/terms-of-service/" style={{color:'#999', textDecoration: 'underline', textShadow: '0 1px 0 #FFFFFF'}}>Terms and Conditions</a>
                </p>
            </div>
        </div>
    )
};

export default SavorPinterest
